import { Component, Input } from '@angular/core';

@Component({
    selector: 'atx-tooltip',
    template: `<nz-tooltip [nzTitle]="message"
            [nzPlacement]="placement">
    <span nz-tooltip
          [class]="clazz">
        {{ label }}
    </span>
</nz-tooltip>
`,
    styles: [``],
})

export class AtxTooltipComponent {
    @Input() public readonly label: string;
    @Input() public readonly clazz: string;
    @Input() public readonly message: string;
    @Input() public readonly placement: string;
}
